module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i82Ld"))).then(() => parcelRequire('ikE14'));